import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EmailsComponent } from './emails.component';
import { EmailsModalComponent } from './modals/emails/emails.component';

@NgModule({
  imports: [CommonModule, EmailsComponent, EmailsModalComponent],
  exports: [EmailsComponent],
})
export class EmailsModule {}
